import { render } from "./404.vue?vue&type=template&id=5804b647&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=5804b647&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5804b647"]])

export default __exports__